import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Outline = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 28 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M6.5625 19.6875C9.1875 24.5 14.875 26.25 22.75 22.3125C19.95 20.5625 10.7917 19.8333 6.5625 19.6875Z"
        fill={color}
        stroke={color}
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <path
        d="M14 21.875C7 27.5625 3.0625 12.25 3.0625 6.5625C6.125 8.3125 10.0625 9.1875 13.125 8.75C14 16.1875 21.4375 20.5625 24.5 20.5625C23.1875 22.75 18.375 25.8125 14 21.875Z"
        fill="white"
        stroke={color}
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <path
        d="M18.9003 10.9002L23.39 8.51508C23.9066 8.24061 24.0783 7.58317 23.7619 7.09109L23.7285 7.0391C23.412 6.54702 22.7426 6.43049 22.2785 6.78669L18.2456 9.88203C17.995 10.0744 17.9337 10.4267 18.1045 10.6924C18.2754 10.958 18.6214 11.0484 18.9003 10.9002Z"
        fill={color}
      />
      <path
        d="M19.9754 15.4792L25.0589 15.5418C25.6439 15.549 26.1101 15.0547 26.0687 14.4711L26.0643 14.4095C26.0229 13.8259 25.4916 13.4023 24.9135 13.4921L19.8898 14.2717C19.5776 14.3202 19.3547 14.5998 19.3771 14.9149C19.3994 15.23 19.6596 15.4753 19.9754 15.4792Z"
        fill={color}
      />
      <path
        d="M16.6833 8.13572L18.4024 3.35133C18.6002 2.80075 18.2852 2.19868 17.7201 2.04726L17.6604 2.03126C17.0953 1.87984 16.5215 2.24375 16.4175 2.81948L15.5141 7.82241C15.4579 8.13326 15.6494 8.43525 15.9546 8.51701C16.2597 8.59877 16.5765 8.43299 16.6833 8.13572Z"
        fill={color}
      />
      <path
        d="M6.125 11.8125C8.3125 12.25 10.5 12.25 11.375 12.25"
        stroke={color}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M7 14.875C9.1875 15.3125 12.25 15.3125 13.125 15.3125"
        stroke={color}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M8.3125 17.5C10.5 17.9375 14 17.9375 15.3125 17.5"
        stroke={color}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M9.625 20.125C10.9375 20.5625 11.8125 20.5625 13.125 20.125"
        stroke={color}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  )
})

export default Outline
